<div class="carousel-container" dir="ltr">
  <p-carousel
    *ngIf="data?.fullWidthImages?.length"
    [value]="data.fullWidthImages"
    [circular]="data?.fullWidthImages?.length > 1"
    [autoplayInterval]="3000"
    [showNavigators]="data?.fullWidthImages?.length > 1"
    [showIndicators]="false"
    [ngClass]="{ 'd-none d-md-block': data?.smallWidthImages?.length }"
    (onPage)="onSlideChange($event)"
  >
    <ng-template pTemplate="item" let-item let-i="index">
      <div class="carousel-item-container text-center">
        <img
          [src]="item.imageUrl"
          [class]="item.fullWidth === false ? 'detailes-img' : 'w-100 hero-image'"
          alt="carousel-image"
        />
        <div
          class="carousel-overlay"
          [@fadeInUp]="i === currentIndex ? 'visible' : 'hidden'"
          *ngIf="item.title"
        >
          <h2 class="carousel-title">{{ item.title }}</h2>
          <button
            class="carousel-btn"
            (click)="navigateWithQuery(item.fileName)"
          >
            Details
          </button>
        </div>
      </div>
    </ng-template>
  </p-carousel>

  <p-carousel
    *ngIf="data?.smallWidthImages?.length"
    [value]="data.smallWidthImages"
    [circular]="false"
    [autoplayInterval]="3000"
    [showNavigators]="false"
    [showIndicators]="false"
    class="d-block d-md-none"
  >
    <ng-template pTemplate="item" let-img>
      <img [src]="img" class="w-100" alt="carousel image" />
    </ng-template>
  </p-carousel>
</div>
